import React, { useState } from "react";
import axios from "axios";

export default function MITPage() {
  const [chargeID, setChargeID] = useState("");
  const [status, setStatus] = useState(null);
  const [errorData, setErrorData] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus(null);
    setErrorData(null);

    try {
      const res = await axios.post("https://tp-api.alsendi.me/repay", {
        id: chargeID,
      });
      window.location.href ="https://tap-payment.alsendi.me/payment-status?tap_id="+res.data.newCharge.id;
      setStatus(res.data.status);
    } catch (err) {
      console.error(err);
      setErrorData(err.message || "Error fetching status");
    }
  };

  return (
    <div className="App">
      <header className="App-header">
        <h1>MIT Repay Page</h1>
        <h4>Developed By Ali AlSendi</h4>
      </header>

      <main className="App-main">
        <div className="card-container">
          <form onSubmit={handleSubmit}>
          <div className="mb-4 w-full max-w-md">
  <label htmlFor="charge-id" className="block text-sm font-medium text-gray-700 mb-1">
    Charge ID
  </label>
  <br />
  <br />

  <input
    id="charge-id"
    type="text"
    value={chargeID}
    onChange={(e) => setChargeID(e.target.value)}
    placeholder="Enter Charge ID"
    required
    className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-150"
  />
</div>
            <br />
            <button className="pay-button"  type="submit">Repay (MIT)</button>
          </form>

          {status && (
            <div style={{ marginTop: "1rem", color: "green" }}>
              <strong>Status:</strong> {status}
            </div>
          )}

          {errorData && (
            <div style={{ marginTop: "1rem", color: "red" }}>
              <strong>Error:</strong> {errorData}
            </div>
          )}
        </div>
      </main>
    </div>
  );
}